import axios from 'axios';

// 🎯 SINGLE CONFIGURATION - true = local server (localhost:30020), false = production API
const IS_DEVELOPMENT = false; // ← Set to false before deploying to production

const getApiUrl = () => {
  if (IS_DEVELOPMENT) {
    return 'http://localhost:30020';
  } else {
    return 'https://leads-automater-api.nowgray.live';
  }
};

// Configure axios defaults
const apiUrl = getApiUrl();

const apiClient = axios.create({
  baseURL: apiUrl,
  timeout: 90000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Don't auto-redirect on 401 - let AuthContext handle it
    // This prevents double-handling and race conditions
    return Promise.reject(error);
  }
);

export default apiClient;
export { getApiUrl };
